import { IChannelSettings } from "@Interfaces";

/**
 * Determines if data collection is required based on channel/poll settings.
 * Checks for email collection, demographics, custom variables, and custom text fields.
 *
 * @param settings - Channel or poll settings
 * @returns boolean - True if any data collection is enabled, false otherwise
 */
export const isDataCollectionRequired = (
    settings: IChannelSettings | undefined
): boolean => {
    if (!settings) return false;

    const isEmailRequired = settings["is_email_required"];
    const demographicFields = settings.demographic_fields;
    const hasActiveDemographics =
        !!demographicFields &&
        Object.values(demographicFields).some((value) => value);
    const hasCustomVariables =
        !!settings["custom_variables"] &&
        (settings["custom_variables"] as any[]).length > 0;
    const hasCustomTextField = !!settings["custom_text_field_enabled"];

    return (
        !!isEmailRequired ||
        hasActiveDemographics ||
        hasCustomVariables ||
        hasCustomTextField
    );
};
